import './styles.scss';

import React, {useState} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {useQuery} from "react-query";
import UserApi from "../../../api/User/User.api";
import useUserStore from "../../../data/User.store";
import DefaultLoader from "../../common/DefaultLoader/DefaultLoader";
import UsersInfoForm from "../Users.info.form/Users.info.form";
import {Tabs} from "antd";
import BrowserRouter, {BrowserRoutes} from "../../../routes/BrowserRouter";
import UsersAlerts from "../Users.alerts/Users.alerts.component";
import Dashboard from '../../../containers/Dashboard/Dashboard';
import UserRoleSelect from "../User.roles.select/User.roles.select";
import {ROLES} from "../../../settings";

interface Props {
    userId?: string,
}

function UsersSettings({userId}: Props) {
    const {user} = useUserStore();
    const [userIsLoading, setUserIsLoading] = useState(false);

    async function getUserFn() {
        if (isCurrentUser()) {
            return await UserApi.getMe();
        } else {
            return await UserApi.getUserById(parseInt(userId));
        }
    }

    const {isLoading, data, refetch} = useQuery(`fetchSingleUser-${userId || user.id}`, getUserFn);


    function isCurrentUser() {
        return !userId;
    }

    if (isLoading && !data) {
        return (
            <div className='default-loader-full'>
                <DefaultLoader text='Loading user...'/>
            </div>
        )
    }

    async function onSubmitSettingsChange(values: any) {
        let ret = {...values, company_id: data?.company?.id}
        ret.user_id = userId || user.id;
        let curUser = await UserApi.acceptInvitation(ret);
        if (curUser) {
            await refetch()
        }
    }

    async function updateUserRole(roleName:string){
        setUserIsLoading(true);
        await UserApi.updateUserRole(data.id, roleName);
        await refetch();
        setUserIsLoading(false);
    }

    function onTabChange(key: string) {
        BrowserRouter.push(BrowserRoutes.getUsersById(parseInt(userId)) + `/${key}`);
    }

    function renderTabs()
    {
        if (!isCurrentUser()) {
            if (user?.role?.name === ROLES.ADMIN) {
                return (
                    <Switch>
                        <Route path={BrowserRoutes.usersTabbedParam} render={({match}) => (
                            <Tabs defaultActiveKey={match.params.tabId} onChange={onTabChange}>
                                <Tabs.TabPane tab="Settings" key="settings">
                                    <UsersInfoForm user={data} onSubmit={onSubmitSettingsChange}/>
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Dashboard" key="dashboard">
                                    <Dashboard userId={userId}/>
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Alerts" key="alerts">
                                    <UsersAlerts userId={userId}/>
                                </Tabs.TabPane>
                            </Tabs>
                        )}/>
                        <Redirect to={BrowserRoutes.getUsersSettingsById(parseInt(userId))}/>
                    </Switch>
                )
            }
            else {
                return (
                    <Switch>
                        <Route path={BrowserRoutes.usersTabbedParam} render={({match}) => (
                            <Tabs defaultActiveKey={match.params.tabId} onChange={onTabChange}>
                                <Tabs.TabPane tab="Dashboard" key="dashboard">
                                    <Dashboard userId={userId}/>
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Alerts" key="alerts">
                                    <UsersAlerts userId={userId}/>
                                </Tabs.TabPane>
                            </Tabs>
                        )}/>
                        <Redirect to={BrowserRoutes.getUsersDashboardById(parseInt(userId))}/>
                    </Switch>
                )
            }
        }
    }

    return (
        <div className='users-settings'>
            <div className='users-settings-header'>
                <div className='left'>
                    <div className='title'>
                        {data?.first_name} {data?.last_name}
                    </div>
                    <div className='subtitle'>
                        {data?.email}
                    </div>
                </div>
                <div className='right'>
                    {user?.role?.name === ROLES.ADMIN &&
                    <UserRoleSelect roles={Object.values(ROLES)} value={data?.role?.name} onChange={updateUserRole} loading={isLoading || userIsLoading}/>}
                </div>
            </div>
            <div className='users-settings-content'>
                {renderTabs()}
                {isCurrentUser() &&
                <div style={{padding: '0 24px 24px 24px'}}>
                    <UsersInfoForm user={data} onSubmit={onSubmitSettingsChange}/>
                </div>
                }
            </div>
        </div>
    )
}

export default UsersSettings;